<library-wrapper-component
  class="perfect-scroll"
  [libraryType]="libraryStore.library.type"
  [library]="libraryStore.libraryItems"
  (onScrollChanged)="onScroll()"
>
</library-wrapper-component>
